import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ce8ad056&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ce8ad056&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8ad056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce8ad056')) {
      api.createRecord('ce8ad056', component.options)
    } else {
      api.reload('ce8ad056', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ce8ad056&scoped=true", function () {
      api.rerender('ce8ad056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/my_text_align/index.vue"
export default component.exports